import { ProspectProfileClient } from '@/marketing/braze'
import { EmailMarketingResponse, Question } from '../../types'

/**
 * Implements a question that collects an email address from the user.
 * I've done this as a class to allow an arbritrary Prospect tracking client
 * to be passed in. This is useful for testing.
 */

class CollectEmailStep implements Question {
  type = 'question' as const

  title: string = ''

  inputType = { component: 'collectEmail' as const }

  nextButtonText = 'Submit'

  required = true

  /* eslint-disable no-useless-constructor */
  /* eslint-disable no-empty-function */
  constructor(
    public id: string,
    public next: string,
    private prospectTrackingClient: ProspectProfileClient
  ) {}
  /* eslint-enable no-empty-function */
  /* eslint-enable no-useless-constructor */

  onContinue(_, answer) {
    const {
      marketingConsentGiven,
      emailAddress,
      validEmailSupplied,
    } = answer as EmailMarketingResponse

    if (!validEmailSupplied || !emailAddress) {
      throw new Error(
        'Should not be able to progress to here without a valid email'
      )
    }

    if (marketingConsentGiven) {
      this.prospectTrackingClient.setProspectOptedIn(emailAddress)
    } else {
      this.prospectTrackingClient.setProspectUnsubscribed(emailAddress)
    }
  }
}

export default CollectEmailStep
